<template>
  <v-card class="mb-4" outlined>
    <v-card-title class="section-header">
      <v-icon left color="grey darken-1">mdi-clock-outline</v-icon>
      {{ $t("time_settings") }}
    </v-card-title>
    <v-card-text class="pt-4">
      <v-radio-group v-model="restaurant.company_restaurant_settings.delivery_settings" hide-details class="mt-0" @change="onChange">
        <v-radio
          :label="$t('no_time_selection')"
          value="no_delivery_time"
          color="deep-orange"
        ></v-radio>
        <v-radio
          :label="$t('user_sets_time')"
          value="user_delivery_time"
          color="deep-orange"
        ></v-radio>
        <v-radio
          :label="$t('user_chooses_delivery_times')"
          value="choose_delivery_time"
          color="deep-orange"
        ></v-radio>
      </v-radio-group>

      <!-- Delivery Times -->
      <div
        v-if="restaurant && restaurant.company_restaurant_settings.delivery_settings == 'choose_delivery_time'"
        class="mt-4 pa-3 grey lighten-4 rounded"
      >
        <div class="caption grey--text text--darken-1 mb-2">
          {{ $t("delivery_times") }}
        </div>
        <div class="d-flex flex-wrap align-center">
          <v-chip
            v-for="(time, i) in restaurant.times"
            :key="i"
            close
            small
            class="ma-1"
            @click:close="removeTime(i)"
          >
            {{ time }}
          </v-chip>
          <v-menu
            v-model="timeMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn x-small text color="deep-orange" v-bind="attrs" v-on="on">
                <v-icon small left>mdi-plus</v-icon>
                {{ $t("add") }}
              </v-btn>
            </template>
            <v-time-picker
              v-if="timeMenu"
              v-model="selectedTime"
              format="24hr"
              full-width
              color="deep-orange"
              @click:minute="confirmTime"
            ></v-time-picker>
          </v-menu>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import hasSnackbar from "@/mixins/hasSnackbar";
import companyService from "@/services/company";

export default {
  name: "TimeSettingsCard",
  mixins: [hasSnackbar],
  props: {
    value: {
      type: String,
      default: "no_delivery_time",
    },
    restaurant: {
      type: Object,
      default: null,
    },
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      timeMenu: false,
      selectedTime: null,
    };
  },
  methods: {
    confirmTime() {
      if (this.restaurant && this.selectedTime) {
        this.restaurant.times.push(this.selectedTime);
      }
      this.timeMenu = false;
      this.selectedTime = null;
    },
    removeTime(index) {
      if (this.restaurant) {
        this.restaurant.times.splice(index, 1);
      }
    },
    onChange(newValue) {
      this.$emit('save');
    },
  },
};
</script>

<style scoped>
.section-header {
  font-size: 0.95rem;
  font-weight: 500;
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #eee;
}
</style>

<style>
/* Radio button alignment - unscoped for Vuetify components */
.time-settings-card .v-radio {
  align-items: center !important;
}

.time-settings-card .v-radio .v-input--selection-controls__input {
  align-self: center !important;
  margin-top: 0 !important;
}

.time-settings-card .v-radio .v-label {
  display: flex;
  align-items: center !important;
}
</style>
